export const

    SET_AUTO_MESSAGE = 'SET_AUTO_MESSAGE',
    SET_OPEN_STATE = 'SET_OPEN_STATE',
    SET_MESSAGE_DURATION = 'SET_MESSAGE_DURATION';



// WEBPACK FOOTER //
// ./redux/actions/types.js